<div class="d-flex flex-column">
  <mat-form-field [hideRequiredMarker]="true" class="mb-2">
    <mat-label>New Password</mat-label>
    <input
      matInput
      type="password"
      name="newPassword"
      [(ngModel)]="formData().newPassword"
      autocomplete="new-password"
      required
      minlength="6"
    />
    <mat-hint align="start">Must be at least 6 characters long.</mat-hint>
  </mat-form-field>
  <mat-form-field [hideRequiredMarker]="true">
    <mat-label>Confirm Password</mat-label>
    <input
      matInput
      type="password"
      name="passwordConfirmation"
      [(ngModel)]="passwordConfirmation"
      #passConfirmation="ngModel"
      autocomplete="new-password"
      required
      minlength="6"
      [authMatchingPassword]="formData().newPassword"
    />
    @if (passConfirmation.errors?.['passwordNoMatch']) {
      <mat-error>Entered passwords must match</mat-error>
    }
  </mat-form-field>
</div>
